'use client';

import { useNavbar } from '@/hooks/useNavbar';
import NavbarServer from './server';
import type { NavbarClientProps } from './type';

export function NavbarClient({
  hideBadge,
  showFreeCaseReviewButton = true,
  showTalkToSpecialistButton = true,
  claimSections,
  locations,
  initialTop,
  minTop,
  className,
  ctaAction,
  ctaHref,
  navLinks,
  phone,
  hideMobileBottomNav,
}: NavbarClientProps) {
  const {
    isScrolled,
    isMenuOpen,
    openMenu,
    toggleMenuOpen,
    openDesktopMenu,
    top,
    transitionToTop,
    isMobile,
    bottom,
    scrollToForm,
  } = useNavbar(initialTop, minTop);
  return (
    <NavbarServer
      top={top}
      initialTop={initialTop}
      transitionToTop={transitionToTop}
      isScrolled={isScrolled}
      isMenuOpen={isMenuOpen}
      openMenu={openMenu}
      onToggleMenuOpen={toggleMenuOpen}
      onOpenDesktopMenu={openDesktopMenu}
      hideBadge={hideBadge}
      showFreeCaseReviewButton={showFreeCaseReviewButton}
      showTalkToSpecialistButton={showTalkToSpecialistButton}
      claimSections={claimSections}
      locations={locations}
      isMobile={isMobile}
      bottom={bottom}
      className={className}
      onClickCta={ctaAction === 'scroll_to_form' ? scrollToForm : undefined}
      ctaHref={ctaHref}
      navLinks={navLinks}
      phone={phone}
      hideMobileBottomNav={hideMobileBottomNav}
    />
  );
}

export default NavbarClient;
